/**
 * package: com.inq.flash.client.chatskins
 * class: ChatTextFocusMonitorImplIphoneSafari
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS11 = function() {
	com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS11.__super__.call(this);
};
/* __super__ is defined below, and used above :)
 * This is OK because below is operated at load time (as is the definition of the constructor).
 * Above is operated at construction time.
 */
$hxClasses.extend(com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS10,		// The extend defines the __super__
                  com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS11,
                  "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplIphoneCRiOS11"
                 );
